import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const futureTaxDataSchema = z.object({
  /** Transaction history ID, e.g. "1" */
  id: z.string(),
  /** symbol, e.g. "TRXUSDT" */
  symbol: z.string(),
  /** margin Coin, e.g. "USDT" */
  marginCoin: z.string(),
  /** Futures transaction type */
  futureTaxType: z.string(),
  /** Quantity, e.g. "0.10545" */
  amount: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Transaction fee, e.g. "-0.02134863" */
  fee: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** When this record was generated, millisecond timestamp, e.g. "1679909309766" */
  ts: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
})

export type FutureTaxData = z.infer<typeof futureTaxDataSchema>
